module.exports = __webpack_public_path__ + "img/5.12f914a8.png";